import { Header } from "../components/header";
import PicOne from "../assets/story-1.png";
import PicTwo from "../assets/modern-italian.png";
import PicThree from "../assets/join-us.png";
import { Footer } from "../components/footer";
import { useEffect } from "react";
import { trackPageView } from "../utils/segment";

export function Story() {
  useEffect(() => {
    trackPageView("Story Page Viewed");
  }, []);
  return (
    <>
      <Header />
      <div className="container-fluid story-container">
        <div className="hero">
          <p className="hero-content">
            Some people take wine too seriously. We take friendship seriously.
          </p>
          <p className="hero-content-sub">
            No rules. No snobbery. Just good wine and great vibes.
          </p>
        </div>
        <div className="stories">
          <div className="story">
            <img src={PicOne} alt="friend" className="img-fluid" />
            <div className="">
              <h3>More than a drink — it's a shared moment </h3>
              <p>Every bottle tells a story of friendship and celebration</p>
            </div>
          </div>
          <div className="story">
            <img src={PicTwo} alt="friend" className="img-fluid" />
            <div className="">
              <h3>Modern Italian Heritage</h3>
              <p>Tradition meets contemporary style</p>
            </div>
          </div>
          <div className="story">
            <img src={PicThree} alt="friend" className="img-fluid" />
            <div className="">
              <h3>Join the Movement</h3>
              <p>Where every glass brings people together</p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
